// Recovered compiled webpack factory 36825. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { Q: () => o, d: () => a });
  var n = r(38599);
  function a(e, t, r) {
    n.j.document && n.j.addEventListener(e, t, r);
  }
  function o(e, t, r) {
    n.j.document && n.j.removeEventListener(e, t, r);
  }
}
